import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Icon,
  Tooltip,
} from '@mui/material';

import * as brandColors from '../../utils/brandColors';
import { formatDate } from '../../utils/dateHelper';

class TaskStateLabel extends React.Component {
  render() {
    const {
      completed,
      archived,
      dueDate,
      priorDayTask,
      createdDate,
      isTaskScheduled,
      scheduledTime,
      isTaskCreated,
      iconFontSize,
      hideComplete,
    } = this.props;

    const currentDateTimestamp = new Date().getTime();

    if (archived) {
      return (
        <Icon
          style={{
            marginRight: 4,
            fontSize: iconFontSize,
            color: brandColors.grey[500],
          }}
        >
          delete
        </Icon>
      );
    }

    if (completed) {
      return (
        hideComplete
          ? <Box />
          : (
            <Icon
              style={{
                marginRight: 4,
                fontSize: iconFontSize,
                color: brandColors.primary.main,
              }}
            >
              check_box
            </Icon>
          )
      );
    }

    if (dueDate !== null && new Date(dueDate).getTime() < currentDateTimestamp) {
      return (
        <Tooltip title={`This task is past due: ${formatDate(dueDate)}`}>
          <Icon
            style={{
              marginRight: 4,
              fontSize: iconFontSize,
              color: brandColors.danger.main,
            }}
          >
            notification_important
          </Icon>
        </Tooltip>
      );
    }

    if (priorDayTask) {
      return (
        <Tooltip title={`Created ${formatDate(createdDate)}`}>
          <Icon
            style={{
              marginRight: 4,
              fontSize: iconFontSize,
              color: brandColors.grey.main,
            }}
          >
            calendar_month_outlined
          </Icon>
        </Tooltip>
      );
    }

    if (isTaskScheduled) {
      return (
        <Tooltip title={`Scheduled ${formatDate(scheduledTime)}`}>
          <Icon
            style={{
              marginRight: 4,
              fontSize: iconFontSize,
            }}
          >access_time
          </Icon>
        </Tooltip>
      );
    }

    if (!isTaskCreated) {
      return (
        <Tooltip title="No task created">
          <Icon
            style={{
              marginRight: 4,
              fontSize: iconFontSize,
              color: brandColors.grey.main,
            }}
          >
            info_outlined
          </Icon>
        </Tooltip>
      );
    }

    return '';
  }
}

TaskStateLabel.propTypes = {
  completed: PropTypes.bool,
  archived: PropTypes.bool,
  dueDate: PropTypes.any,
  priorDayTask: PropTypes.bool,
  createdDate: PropTypes.any,
  isTaskScheduled: PropTypes.bool,
  scheduledTime: PropTypes.any,
  isTaskCreated: PropTypes.bool,
  iconFontSize: PropTypes.number,
  hideComplete: PropTypes.bool,
};

TaskStateLabel.defaultProps = {
  completed: false,
  archived: false,
  dueDate: null,
  priorDayTask: false,
  createdDate: new Date(),
  isTaskScheduled: false,
  scheduledTime: new Date(),
  isTaskCreated: false,
  iconFontSize: 18,
  hideComplete: false,
};

export default TaskStateLabel;
